import Script from 'next/script';
// this must be placed inside the <body /> tag per comscore instructions

const script = `
  var _comscore = _comscore || [];
  _comscore.push({ c1: "2", c2: "22118392" });
  (function() {
    var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
    s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
    el.parentNode.insertBefore(s, el);
  })();`;

const Comscore = () => (
  <>
    <Script
      id="comscore-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: script }}
    />
    <noscript>
      <img src="http://b.scorecardresearch.com/p?c1=2&c2=22118392&cv=2.0&cj=1" />
    </noscript>
  </>
);

export default Comscore;
